import { BaseAPI } from "./Common";

class File extends BaseAPI {
  getUrl(file_type: string) {
    let payload = { file_type };
    return this.makeRequest("upload", "post", payload).then(response => {
      return response;
    });
  }

  // Upload file to external S3-compatible endpoint
  async remoteUploadFile(url: string, file: any) {
    const response = await fetch(url, {
      method: "PUT",
      body: file,
      headers: {
        // "x-amz-acl": "public-read",
        "Content-Type": file.type,
      },
    });

    return response;
  }

  async getSignedUrls(fileIds: Array<string>) {
    
    
    return Promise.all(fileIds.map(async (id) => {
        return this.makeRequest(id, "get")
    }))
      .then(res => {
        return res;
      })
  }

  async getFileData(id: string) {
    return await this.makeRequest(`${id}`, "get",)
  }
}

export const file = new File("files");
